import React from 'react';
import { Link } from 'react-router-dom';

import Redo from '../App/Redo';
import Banner from '../App/Banner';

import Check from '../../assets/check.svg'
import UK135 from '../../assets/categories/UK.png'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function CustomsFees() {
  return(
    <div>
      <Banner />
      <div id="CustomsFees" className='paper'>

      <Link to='/PlatformUK'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
      </Link>

      <div className='breadcrumbs'>
          <p><img src={Check} />Votre stock se situe en Europe</p>
          <p><img src={Check} />Vous vendez vers le Royaume Uni</p>
          <p><img src={Check} />Le colis est supérieur à 135£</p>
      </div>

        <h4>La procédure :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Faites la demande d’immatriculation à la TVA UK</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA UK</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Payez le droit de douane</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Payez la TVA au moment de l’importation, sur la déclaration nationale du pays de destination</ul>

        <hr />

        <div className='categorie' >
          <h4>Si vous êtes client Dougs :</h4>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie “ventes de marchandises exonérées” et indiquez le montant HT</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Ajoutez un détail</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez “TVA collectée service au Royaume-Uni” et indiquez le montant de la TVA</ul>
          <img src={UK135} alt="Categorie superieur a 135£" style={{marginTop: "2em"}} />
        </div>

        <div className="button">
          <Redo />
        </div>
      </div>

    </div>
  )
}

export default CustomsFees